(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-seen-in"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const resizeBefore = () => {
      const elem = document.querySelector('[data-section-wrapper-id]');
      if (!elem) return;
      if (window.innerWidth < 1200) {
        const mainImage = elem.querySelector('.swiper-slide-active .asi-slide__image');
        const distanceTop = Math.abs(elem.getBoundingClientRect().top - mainImage.getBoundingClientRect().top);
        const beforeHeight = distanceTop + (mainImage.offsetHeight / 2);
        elem.style.setProperty('--before-height', `${beforeHeight}px`);
      }
      else {
        const shopSection = elem.querySelector('.swiper-slide-active .asi-slide__shop');
        const distanceTop = Math.abs(elem.getBoundingClientRect().top - shopSection.getBoundingClientRect().top);
        elem.style.setProperty('--before-height', `${distanceTop}px`);
      }
    }
    resizeBefore();
    window.addEventListener('resize', () => {
      window.requestAnimationFrame(() => {
        resizeBefore();
      });
    });
  });

  new Swiper(".seen-in-slider", {
    spaceBetween: 25,
    slidesPerView: 1.3,
    centeredSlides: !0,
    freeMode: false,
    roundLengths: !0,
    navigation: {
      nextEl: ".seen-in-slider ~ .swiper-button-next",
      prevEl: ".seen-in-slider ~ .swiper-button-prev",
    },
    breakpoints: {
      600: {
        slidesPerView: 1.3,
        spaceBetween: 10,
        freeMode: false,
        centeredSlides: !0,
      },
      750: {
        slidesPerView: 1.3,
        spaceBetween: 20,
        freeMode: false,
        centeredSlides: !0,
      },
      1200: {
        slidesPerView: 1,
        spaceBetween: 60,
        freeMode: false,
        centeredSlides: !0,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  new Swiper(".collection-slider", {
    spaceBetween: 25,
    slidesPerView: 1.3,
    centeredSlides: !0,
    freeMode: !0,
    preloadImages: !1,
    lazy: !0,
    freeModeMomentumBounce: !1,
    navigation: {
      nextEl: ".collection-slider ~ .swiper-button-next",
      prevEl: ".collection-slider ~ .swiper-button-prev",
    },
    breakpoints: {
      600: {
        slidesPerView: 2.3,
        spaceBetween: 10,
        freeMode: !1,
        centeredSlides: !1,
      },
      750: {
        slidesPerView: 3,
        freeMode: !1,
        centeredSlides: !1,
      },
    },
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heirlooms-heirloom-outfits"] && !Shopify.designMode) return;
  try {
    
   new Swiper(".heirlooms-slider", {
    slidesPerView: "auto",
    spaceBetween: 10,
    loop: !0,
    navigation: {
      nextEl: ".heirlooms-slider ~ .swiper-button-next",
      prevEl: ".heirlooms-slider ~ .swiper-button-prev",
    },
    breakpoints: {
      414: {
        slidesPerView: 1.3,
        spaceBetween: 40,
      },
      750: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      1301: {
        slidesPerView: 3,
        spaceBetween: 15,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-header"] && !Shopify.designMode) return;
  try {
    
  new Swiper(".hero-swiper", {
    direction: "vertical",
    touchReleaseOnEdges: !0,
    mousewheel: {
      releaseOnEdges: !0,
    },
    pagination: {
      el: ".swiper-pagination.hero-pagination",
      clickable: !0,
    },
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  new Swiper(".testimonial-slider", {
    slidesPerView: 1,
    loop: !1,
    navigation: {
      nextEl: ".testimonial-slider ~ .swiper-button-next",
      prevEl: ".testimonial-slider ~ .swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination.testimonial",
      clickable: !0,
    },
  });

  } catch(e) { console.error(e); }
})();
})();
